import React from "react";
import { Image } from "react-bootstrap";
import moment from "moment";
import { ORDER_TYPE, PAYMENT_TYPE } from "../../../../../enums/OrderEnums";
function TableHeadScan(props) {
  return (
    <tr>
      <th style={{ width: "150px" }}>
        Request Type/
        <br />
        Request ID
      </th>
      <th style={{ width: "150px" }}>User Name</th>
      <th style={{ width: "150px" }}>Invoice ID</th>
      <th style={{ width: "150px" }}>Payment Gateway</th>

      <th style={{ width: "150px" }}>
        Payment Method/ <br />
        Transaction ID
      </th>
      <th style={{ width: "150px" }}>
        Net <br />
        Amount
      </th>
      <th style={{ width: "150px" }}>
        Order <br />
        Total
      </th>
      <th style={{ width: "150px" }}>Tip</th>
      <th style={{ width: "150px" }}>Donation</th>
      <th style={{ width: "150px" }}>
        Remittance <br />
        Status/ID
      </th>
      <th style={{ width: "150px" }}>
        Merchant Account <br />
        No. & IFSC
      </th>
      <th style={{ width: "150px" }}>
        Settlement Date <br />& Time
      </th>
    </tr>
  );
}

export default TableHeadScan;

export const TableBodyScan = (props) => {
  const data = props.data;
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", lineBreak: "anywhere" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
                // style={{ textAlign: "center" }}
              >
                <td style={{ width: "150px", paddingLeft: "2rem" }}>
                  <div className="f12-500">
                    {ORDER_TYPE[data?.order?.order_type]} 
                  </div>
                  <div className="f12-400">{data?.order?.order_id}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.order?.user_id?.first_name}{" "}
                    {data?.order?.user_id?.last_name}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">13531</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">Razorpay</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {PAYMENT_TYPE[data?.order?.payment_method]}
                    <br />
                    {data?.order?.transactional_id?._id}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ {data?.order?.base_amount}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ {data?.order?.total_amount}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  {data?.order?.settle_payment_status === 3 && (
                    <div className="badge badge-success">Settled</div>
                  )}
                  <div className="f12-500">
                    {data?.order?.transactional_id?._id}
                  </div>
                </td>{" "}
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.settlement_account_details?.account_number}/{" "}
                  </div>
                  <div className="f12-500">
                    {data?.settlement_account_details?.account_ifsc}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {moment(data?.createdAt).format("ll")}
                    <br />
                    {moment(data?.createdAt).format("LT")}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
